//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import hasWindow from '~/mixins/hasWindow'

export default {
  mixins: [hasWindow],
  data() {
    return {
      isGacha: false,
      isLoadingGacha: false,
      isLoading: false,
      point: '0 GP',
      showWording: false,
      termConditionType: '',
      productId: '',
      productCode: 0,
    }
  },
  methods: {
    startGacha() {
      this.$auth.authCheck((isPass) => {
        if (isPass && this.$auth.user) {
          this.getPoint()
        } else {
          this.$router.push('/auth/?redirectTo=/gold-points/gacha')
        }
      })
    },
    showTnc() {
      this.termConditionType = 'gacha'
      this.$refs.termCondition.modal.show()
    },
    async getPoint() {
      try {
        this.showWording = false
        this.isLoading = true
        const response = await this.$axios.get('v1/user-gachas/reward')
        this.point = `+${response.data.data}`
        this.productCode = Number(response.data.product_code)
        this.productId = response.data.product_id

        setTimeout(() => {
          this.isLoading = false
          this.isLoadingGacha = true
        }, 1600)

        setTimeout(() => {
          this.isLoadingGacha = false
          this.isGacha = true
          this.showWording = true
        }, 3400)
      } catch (error) {
        this.$alert.requestError(error)
        this.isGacha = false
        this.isLoading = false
      }
    },
  },
}
